var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-4"},[_c('p',[_vm._v(" "+_vm._s(_vm.$ls.Applications_Requirements_StateFee_Title_ExemptionPaidByCompany)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }